module.exports = __webpack_public_path__ + "img/yonghu5.9d676ed6.png";